import React, { useState , useRef ,useEffect} from "react";

import { ChartNoAxesGantt, ChevronLeft, ChevronRight, Clock, FlameKindling, Grid2x2, Maximize, Minimize, Newspaper, PauseCircle, PlayCircle } from "lucide-react";

import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"



const MockTestTopLoading =({setCloseStartBoxPopUp,testName,fullScreen,isRunning,handleStartPause,overallTestTime,mockTestCard1Object,setQuestionPaperVisible,setFullScreen,enterFullscreen,exitFullscreen})=>{

  const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return `${hrs}:${mins}:${secs}`;
  };
  
    const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
     const [isLoaded, setIsLoaded] = useState(false);
     const [hasError, setHasError] = useState(false);
     
        
             const [reloadItems, setReloadItems] = useState(true);
            
                useEffect(()=>{
                    setReloadItems(false); setReloadItems(true);
                    
                },[ ])
   
                  
     return (
       <div style={{ position: "relative",boxShadow:boxShadow,
       overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
        borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                 borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                 borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                 borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                 
       width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
         {!isLoaded && !hasError && (
           <div
            style={
                { 
                 borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                 borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                 borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                 borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                   position: "absolute",
         top: 0,
         left: 0,
         width: `${width}%`,
         aspectRatio: aspectRatio,
         objectFit: "cover",  }}
          className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
           >
             <img
           src={loading_img}
           alt=""
         
          style={
                {
                borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                 borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                 borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                 borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                 
                   position: "absolute",border:border,
         top: 0,
         left: 0,
         width: `${width}%`,padding:"10px",
       
         objectFit: "cover", aspectRatio: aspectRatio,  }}
          className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
         />
           </div>
         )}
         
         <img
   
         
           src={hasError ? fallback_img : src}
           alt=""
           onLoad={() => setIsLoaded(true)}
           onError={() => setHasError(true)}
          style={
                {
                   position: "absolute",
         top: 0,
         left: 0,
         width: `${width}%`,
        
         objectFit: "cover",aspectRatio: aspectRatio  }}
          className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
         />
       
       </div>
     );
   }; 
    return(<>
     <div className="mockTestTopBarV1" style={{height:"60px" ,boxShadow:"10px 7px 20px 10px rgba(48,25,131,0.041)",
   border:"0px solid #ffffff",
      borderTopLeftRadius:`${mockTestCard1Object?.topSectionCard?.borderRadius?.topLeft?.value}${mockTestCard1Object?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${mockTestCard1Object?.topSectionCard?.borderRadius?.topRight?.value}${mockTestCard1Object?.topSectionCard?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${mockTestCard1Object?.topSectionCard?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.topSectionCard?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${mockTestCard1Object?.topSectionCard?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.topSectionCard?.borderRadius?.bottomRight?.resolution}`,
      }}>
      <div style={{display:"flex",justifyContent:"center",}}> <div className="text-linetw" style={{width:"50px",height:"30px",display:"flex",justifyContent:"center",alignItems:"center",margin:"10px"}}>
       
        
        </div></div> 
     <div className="hideXsForMock hideSmForMock hideMdForMock ellipsisTitleQuiz mockTestTitleFont text-linetw"
      style={{margin:"10px",marginLeft:"0px",height:"30px",width:"95%",fontWeight:"999",display:"flex",justifyContent:"left",alignItems:"center",paddingLeft:"10px"
       ,color:`${mockTestCard1Object?.quizTitleTop?.textColor?.color}`,
      borderTopLeftRadius:`${mockTestCard1Object?.quizTitleTop?.borderRadius?.topLeft?.value}${mockTestCard1Object?.quizTitleTop?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${mockTestCard1Object?.quizTitleTop?.borderRadius?.topRight?.value}${mockTestCard1Object?.quizTitleTop?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${mockTestCard1Object?.quizTitleTop?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.quizTitleTop?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${mockTestCard1Object?.quizTitleTop?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.quizTitleTop?.borderRadius?.bottomRight?.resolution}`,
     }}>
           </div>
    <div  className="hideXsForMock text-linetw" style={{cursor:"pointer",height:"30px",display:"flex",justifyContent:"center",alignItems:"center",margin:"5px",margin:"10px",fontWeight:"999",fontSize:"13px"
   ,
     borderTopLeftRadius:`${mockTestCard1Object?.qPaperBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.qPaperBtn?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${mockTestCard1Object?.qPaperBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.qPaperBtn?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${mockTestCard1Object?.qPaperBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.qPaperBtn?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${mockTestCard1Object?.qPaperBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.qPaperBtn?.borderRadius?.bottomRight?.resolution}`,
    }}><div   className="palletGridList " style={{}} ></div><div className="mockTestButtonFont" style={{color:`${mockTestCard1Object?.qPaperBtn?.textColor?.color}`}}></div></div>
    <div  className="hideXsForMock text-linetw" style={{cursor:"pointer",height:"30px",display:"flex",justifyContent:"center",alignItems:"center",margin:"10px",fontWeight:"999",fontSize:"13px"
      ,
     borderTopLeftRadius:`${mockTestCard1Object?.instructionBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.instructionBtn?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${mockTestCard1Object?.instructionBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.instructionBtn?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${mockTestCard1Object?.instructionBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.instructionBtn?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${mockTestCard1Object?.instructionBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.instructionBtn?.borderRadius?.bottomRight?.resolution}`,
    
    }}><div   className="palletGridList" style={{}}></div><div className="mockTestButtonFont" style={{color:`${mockTestCard1Object?.instructionBtn?.textColor?.color}`}}></div></div>
    <div className="hideXsForMock text-linetw" style={{height:"30px",width:"40px",display:"flex",justifyContent:"center",alignItems:"center",margin:"10px",
     borderTopLeftRadius:`${mockTestCard1Object?.fsBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.fsBtn?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${mockTestCard1Object?.fsBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.fsBtn?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${mockTestCard1Object?.fsBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.fsBtn?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${mockTestCard1Object?.fsBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.fsBtn?.borderRadius?.bottomRight?.resolution}`,
    }}>
            <div   className="palletGridList " style={{}}></div>
     </div>
    <div style={{height:"40px",}}>
    <div style={{display:"flex",justifyContent:"center",alignItems:"center",margin:"10px" ,gap:"10px",}}>
        <div onClick={handleStartPause}  style={{cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center",height:"40px",width:"40px",
     borderTopLeftRadius:`${mockTestCard1Object?.pauseBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.pauseBtn?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${mockTestCard1Object?.pauseBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.pauseBtn?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${mockTestCard1Object?.pauseBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.pauseBtn?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${mockTestCard1Object?.pauseBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.pauseBtn?.borderRadius?.bottomRight?.resolution}`,
    }}>
          { <PlayCircle style={{position:"relative"}}   color={"#f1f1f1"} size={35}/> }
    </div><div className="text-linetw" style={{fontSize:"20px",fontWeight:"999",padding:"5px",margin:"0px",
      borderTopLeftRadius:`${mockTestCard1Object?.quizTimer?.borderRadius?.topLeft?.value}${mockTestCard1Object?.quizTimer?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${mockTestCard1Object?.quizTimer?.borderRadius?.topRight?.value}${mockTestCard1Object?.quizTimer?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${mockTestCard1Object?.quizTimer?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.quizTimer?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${mockTestCard1Object?.quizTimer?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.quizTimer?.borderRadius?.bottomRight?.resolution}`,
    }}>
         </div> </div>
   </div>
    </div></>)
}
export default MockTestTopLoading